import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ObjectWith } from '../../../../../../../cross-team-shared/types/misc';
import { TaskWorkspaceStore } from '../../../../../../h3ml/state/task-workspace-store';
import {
  FeedbackDisplayItem,
  FeedbackListComponent,
} from './feedback-list.component';

export const icons: ObjectWith<string> = {
  'edge-case': 'edgeCaseFeedback',
  'instruction-gap': 'instructionGapFeedback',
  other: 'otherFeedback',
  'sensor-issue': 'sensorIssueFeedback',
  subjectivity: 'subjectivityFeedback',
};

@Component({
  selector: 'h3-client-issue-list',
  templateUrl: './client-issue-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FeedbackListComponent, AsyncPipe],
})
export class ClientFeedbackListComponent {
  feedback$ = this.buildFeedback$();

  constructor(private taskWorkspaceStore: TaskWorkspaceStore) {}

  private buildFeedback$(): Observable<FeedbackDisplayItem[]> {
    return this.taskWorkspaceStore('clientFeedback').$.pipe(
      map((clientFeedbacks) =>
        clientFeedbacks.map((issue) => ({
          id: issue.id,
          outputId: issue.location.output_id,
          title: issue.title,
          errorType: issue.type,
          comment: issue.description,
          startFrame: issue.location.frame_number,
          coordinates: issue.location.coordinates,
          updatedAt: issue.updatedAt,
          iconName: icons[issue.type],
          isClosed: issue.status === 'closed',
        })),
      ),
    );
  }
}
